class ElfsightWidget extends HTMLElement {
  connectedCallback() {
    const platform = document.createElement('script');
    platform.src = 'https://static.elfsight.com/platform/platform.js';
    platform.setAttribute('async', true);
    this.append(platform);

    this.insertAdjacentHTML('beforeend', `<div class="elfsight-app-${this.getAttribute('id')}" data-elfsight-app-lazy></div>`);
  }
}

customElements.define('elfsight-widget', ElfsightWidget);